const ID = 'js-login-progress-bar';

export default {
  loading: () => {
    document.getElementById(ID)?.start?.();
  },
  rejected: () => {
    document.getElementById(ID)?.reset?.();
  },
  resolved: () => {
    document.getElementById(ID)?.complete?.();
  },
};
